import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  title: {
    alignItems: 'center',
    display: 'flex',
  },
  titleText: {
    padding: theme.spacing(0, 1),
  },
  content: {
    padding: theme.spacing(0, 3),
  },
  icon: {
    color: theme.palette.info.dark,
  },
}));
